import Button from "../../../../components/Button";
import { QuizStats } from "../../../../context/QuizContext";
import NumberButton from "./NumberButton";
import {
    Modal,
    ModalContent,
    ModalBody,
    ModalFooter,
    useDisclosure,
} from "@nextui-org/react";

function QuizOverview({ watchFormValues, onSubmit }) {
    const { isOpen, onOpen, onOpenChange } = useDisclosure();
    const {
        getQuestion,
        numberOfQuestions,
        visitedNumber,
        quizQuestions,
        seenQuestions,
    } = QuizStats();

    return (
        <div className="flex flex-col justify-between px-5 py-5 bg-white shadow-lg gap-y-4 rounded-xl">
            <div
                dir="ltr"
                className="grid grid-cols-5 py-5 lg:grid-cols-4 xl:grid-cols-5 md:grid-cols-8 place-items-center gap-y-4"
            >
                {Array.from(
                    { length: numberOfQuestions },
                    (_, index) => index + 1
                ).map((item) => {
                    return (
                        <NumberButton
                            key={item}
                            onClick={() =>
                                item <= visitedNumber
                                    ? getQuestion(item - 1)
                                    : getQuestion(item - 1)
                            }
                            color={
                                seenQuestions.includes(item)
                                    ? watchFormValues?.(
                                          `answer-${
                                              quizQuestions[item - 1]?.id
                                          }`
                                      )
                                        ? "bg-green-color"
                                        : "bg-red-color-primary"
                                    : "bg-gray-color-light"
                            }
                        >
                            {item}
                        </NumberButton>
                    );
                })}
            </div>
            <Button
                type="primary"
                name="end the quiz"
                className="w-full mt-4 leading-9 rounded-md"
                onClick={(e) => {
                    e.preventDefault();
                    onOpen();
                }}
            >
                إنهاء الأختبار
            </Button>

            <div>
                <Modal
                    isOpen={isOpen}
                    onOpenChange={onOpenChange}
                    motionProps={{
                        variants: {
                            enter: {
                                scale: "var(--scale-enter)",
                                y: "var(--slide-enter)",
                                opacity: 1,
                                transition: {
                                    scale: {
                                        duration: 0.4,
                                        ease: [0.36, 0.66, 0.4, 1],
                                    },
                                    opacity: {
                                        duration: 0.4,
                                        ease: [0.36, 0.66, 0.4, 1],
                                    },
                                    y: {
                                        type: "spring",
                                        bounce: 0,
                                        duration: 0.6,
                                    },
                                },
                            },
                            exit: {
                                scale: "var(--scale-exit)",
                                y: "var(--slide-exit)",
                                opacity: 0,
                                transition: {
                                    duration: 0.3,
                                    ease: [0.36, 0.66, 0.4, 1],
                                },
                            },
                        },
                    }}
                >
                    <ModalContent>
                        {(onClose) => (
                            <>
                                <ModalBody className="flex flex-col items-center justify-center pt-5">
                                    <img
                                        src="/images/Question.webp"
                                        alt="Question mark Image"
                                        className="w-32"
                                        decoding="async"
                                        loading="lazy"
                                    />
                                    <p className="text-xl font-semibold text-blue-color-primary">
                                        هل انت متأكد من انك تريد انهاء الأختبار
                                        ؟
                                    </p>
                                </ModalBody>
                                <ModalFooter className="flex items-center justify-center gap-5 pb-6">
                                    <Button
                                        name="end the quiz"
                                        type="primary"
                                        className="w-36"
                                        onClick={() => onSubmit()}
                                    >
                                        إنهاء الأختبار
                                    </Button>
                                    <Button
                                        name="cancel the quiz"
                                        type="customized"
                                        onClick={onClose}
                                        className="px-4 py-2 text-white rounded-full bg-gray-color-light w-36 md:px-6 "
                                    >
                                        إلغاء
                                    </Button>
                                </ModalFooter>
                            </>
                        )}
                    </ModalContent>
                </Modal>
            </div>
        </div>
    );
}

export default QuizOverview;
